import "@/App.css";
import "@/i18n";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Splash from "@/pages/Splash";
import Landing from "@/pages/Landing";
import MarmitasLanding from "@/pages/MarmitasLanding";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import { AuthProvider } from "@/lib/auth";
import { Toaster } from "@/components/ui/sonner";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <Routes>
                        <Route path="/" element={<Splash />} />
                        <Route path="/personal-chef" element={<Landing />} />
                        <Route path="/marmitas" element={<MarmitasLanding />} />
                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route path="/admin" element={<AdminDashboard />} />
                    </Routes>
                </AuthProvider>
            </BrowserRouter>
            <Toaster position="bottom-center" richColors />
        </div>
    );
}

export default App;
